import { subscriptionService } from '@/services/tmed-plans/subscription.service';

const state = {
  subscription: null,
  currentSubscription: null,
  subscriptionStatus: null,
  createSubscriptionStatus: 'init',
  getSubscriptionStatus: 'init',
  cancelSubscriptionStatus: 'init',
  updateSubscriptionStatus: 'init',
  error: null,
};

const getters = {
  getSubscription: (state) => state.subscription,
  getCurrentSubscription: (state) => state.currentSubscription,
  getSubscriptionStatus: (state) => state.subscriptionStatus,
  getCreateSubscriptionStatus: (state) => state.createSubscriptionStatus,
  getGetSubscriptionStatus: (state) => state.getSubscriptionStatus,
  getCancelSubscriptionStatus: (state) => state.cancelSubscriptionStatus,
  getUpdateSubscriptionStatus: (state) => state.updateSubscriptionStatus,
  getError: (state) => state.error,
};

const actions = {
  async createSubscription({ commit }, subscriptionData) {
    try {
      commit('SET_CREATE_SUBSCRIPTION_STATUS', 'loading');
      const response = await subscriptionService.createSubscription(subscriptionData);
      commit('SET_SUBSCRIPTION', response);
      commit('SET_CREATE_SUBSCRIPTION_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao criar assinatura');
      commit('SET_CREATE_SUBSCRIPTION_STATUS', 'init');
      throw error;
    }
  },

  async getSubscription({ commit }, { status, limit } = {}) {
    try {
      commit('SET_GET_SUBSCRIPTION_STATUS', 'loading');
      const params = { status, limit };
      const response = await subscriptionService.getSubscription(params);
      commit('SET_SUBSCRIPTION', response);
      commit('SET_GET_SUBSCRIPTION_STATUS', 'init');
      return response;
    } catch (error) {
      if (error?.response?.status === 404) {
        const emptyResponse = { data: { items: [] } };
        commit('SET_SUBSCRIPTION', emptyResponse);
        commit('SET_CURRENT_SUBSCRIPTION', null);
        commit('SET_GET_SUBSCRIPTION_STATUS', 'init');
        return emptyResponse;
      }
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao buscar assinatura');
      commit('SET_GET_SUBSCRIPTION_STATUS', 'init');
      throw error;
    }
  },

  async cancelSubscription({ commit }, subscriptionId) {
    try {
      commit('SET_CANCEL_SUBSCRIPTION_STATUS', 'loading');
      const response = await subscriptionService.cancelSubscription(subscriptionId);
      commit('SET_CANCEL_SUBSCRIPTION_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao cancelar assinatura');
      commit('SET_CANCEL_SUBSCRIPTION_STATUS', 'init');
      throw error;
    }
  },

  async updateSubscription({ commit }, { orderId, data }) {
    try {
      commit('SET_UPDATE_SUBSCRIPTION_STATUS', 'loading');
      const response = await subscriptionService.updateSubscription(orderId, data);
      commit('SET_UPDATE_SUBSCRIPTION_STATUS', 'init');
      return response;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || 'Erro ao atualizar plano');
      commit('SET_UPDATE_SUBSCRIPTION_STATUS', 'init');
      throw error;
    }
  },

  setCurrentSubscription({ commit }, subscription) {
    commit('SET_CURRENT_SUBSCRIPTION', subscription);
  },

  clearSubscription({ commit }) {
    commit('CLEAR_SUBSCRIPTION');
  },
};

const mutations = {
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },

  SET_CURRENT_SUBSCRIPTION(state, subscription) {
    state.currentSubscription = subscription;
  },

  SET_SUBSCRIPTION_STATUS(state, status) {
    state.subscriptionStatus = status;
  },

  SET_CREATE_SUBSCRIPTION_STATUS(state, status) {
    state.createSubscriptionStatus = status;
  },

  SET_GET_SUBSCRIPTION_STATUS(state, status) {
    state.getSubscriptionStatus = status;
  },

  SET_CANCEL_SUBSCRIPTION_STATUS(state, status) {
    state.cancelSubscriptionStatus = status;
  },

  SET_UPDATE_SUBSCRIPTION_STATUS(state, status) {
    state.updateSubscriptionStatus = status;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },

  CLEAR_SUBSCRIPTION(state) {
    state.subscription = null;
    state.currentSubscription = null;
    state.subscriptionStatus = null;
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
